export const safeOffset = (offset: string | number) => {
  offset = String(offset);
  return offset === '0' ? undefined : offset;
};
